<template>
    <div role="main" class="main agenda">
        <div v-if="ready==false" class="loader">
            <div class="container">
                <div class="row">
                    <div class="col-sm-1 mx-md-auto mt-2 text-center">
                        <spring-spinner
                        :animation-duration="5000"
                        :size="60"
                        color="#124191"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="container">
                <div class="row mt-5 pb-3">
                    <div class="col-md-12 mx-md-auto text-uppercase text-center">
                        <h2 class="font-weight-normal text-9 mb-3">Agenda</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 mx-md-auto text-center">
                        <h3 class="font-weight-normal text-6 mb-3">
                            <span>{{ date }}</span>
                            <img :src="require('../assets/img/pin.png')" style="" alt="" />
                        </h3>
                    </div>
                </div>
                <div>
<!--                  stage 1-->
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="table-agenda">
                        <div class="header">
                          <div class="th">
                            <p>ROOM <span>I</span></p>
                          </div>
                        </div>
                        <template v-for="(s,i) in getSess1">
                          <template v-if="s.session.type === 'break'">
                            <div class="session-content">
                              <div class="break">
                                <div class="session">
                                  <p>
                                    {{ s.session.name }}
                                  </p>
                                </div>
                              </div>
                              <div class="break">
                                <div class="session">
                                  <p>
                                    {{ s.session.time }}
                                  </p>
                                </div>
                              </div>
                              <div class="break"><div class="session">&nbsp;</div></div>
                              <div class="break"><div class="session">&nbsp;</div></div>
                            </div>
                          </template>
                          <template v-else-if="s.session.type === 'session'">
                            <div class="session-content s">
                              <div class="name">
                                <div class="session">
                                  <p>
                                    {{ s.session.name }}
                                  </p>
                                </div>
                              </div>
                              <div class="name">
                                <div class="session">
                                  <p>
                                    {{ s.session.time }}
                                  </p>
                                </div>
                              </div>
                              <div class="name">
                                <div class="session">
                                  <p v-if="hasAuthors(s)">
                                    <strong v-for="at in s.agenda.authors" :key="at.id">
                                      <a :href="'/speaker/'+at.authors.slug">{{ at.authors.first_name }} {{ at.authors.last_name }}</a><em>, </em>
                                    </strong>
                                  </p>
                                </div>
                              </div>
                              <div class="name">
                                <div class="session">
                                  <p v-if="hasLecture(s)">
                                    <a :href="'/2022/'+s.agenda.lecture_slug">
                                      {{ s.agenda.lecture_name }}
                                      <template v-if="s.session.online === true">
                                        <br><span>(online lecture)</span>
                                      </template>
                                    </a>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </template>
                        </template>
                      </div>
                    </div>
                  </div>
<!--                  stage 2-->
                  <div class="row">
                    <br>
                    <br>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="table-agenda">
                        <div class="header">
                          <div class="th">
                            <p>ROOM <span>VII</span></p>
                          </div>
                        </div>
                        <template v-for="(s,i) in getSess2">
                          <template v-if="s.session.type === 'break'">
                            <div class="session-content">
                              <div class="break">
                                <div class="session">
                                  <p>
                                    {{ s.session.name }}
                                  </p>
                                </div>
                              </div>
                              <div class="break">
                                <div class="session">
                                  <p>
                                    {{ s.session.time }}
                                  </p>
                                </div>
                              </div>
                              <div class="break"><div class="session">&nbsp;</div></div>
                              <div class="break"><div class="session">&nbsp;</div></div>
                            </div>
                          </template>
                          <template v-else-if="s.session.type === 'session'">
                            <div class="session-content s">
                              <div class="name">
                                <div class="session">
                                  <p>
                                    {{ s.session.name }}
                                  </p>
                                </div>
                              </div>
                              <div class="name">
                                <div class="session">
                                  <p>
                                    {{ s.session.time }}
                                  </p>
                                </div>
                              </div>
                              <div class="name">
                                <div class="session">
                                  <p v-if="hasAuthors(s)">
                                    <strong v-for="at in s.agenda.authors" :key="at.id">
                                      <a :href="'/speaker/'+at.authors.slug">{{ at.authors.first_name }} {{ at.authors.last_name }}</a><em>, </em>
                                    </strong>
                                  </p>
                                </div>
                              </div>
                              <div class="name">
                                <div class="session">
                                  <p v-if="hasLecture(s)">
                                    <a :href="'/2022/'+s.agenda.lecture_slug">
                                      {{ s.agenda.lecture_name }}
                                      <template v-if="s.session.online === true">
                                        <br><span>(online lecture)</span>
                                      </template>
                                    </a>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </template>
                        </template>
                      </div>
                    </div>
                  </div>
<!--                  stage 3-->
                  <div class="row">
                    <br>
                    <br>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="table-agenda">
                        <div class="header">
                          <div class="th">
                            <p>ROOM <span>IX</span></p>
                          </div>
                        </div>
                        <template v-for="(s,i) in getSess3">
                          <template v-if="s.session.type === 'break'">
                            <div class="session-content">
                              <div class="break">
                                <div class="session">
                                  <p>
                                    {{ s.session.name }}
                                  </p>
                                </div>
                              </div>
                              <div class="break">
                                <div class="session">
                                  <p>
                                    {{ s.session.time }}
                                  </p>
                                </div>
                              </div>
                              <div class="break"><div class="session">&nbsp;</div></div>
                              <div class="break"><div class="session">&nbsp;</div></div>
                            </div>
                          </template>
                          <template v-else-if="s.session.type === 'session'">
                            <div class="session-content s">
                              <div class="name">
                                <div class="session">
                                  <p>
                                    {{ s.session.name }}
                                  </p>
                                </div>
                              </div>
                              <div class="name">
                                <div class="session">
                                  <p>
                                    {{ s.session.time }}
                                  </p>
                                </div>
                              </div>
                              <div class="name">
                                <div class="session">
                                  <p v-if="hasAuthors(s)">
                                    <strong v-for="at in s.agenda.authors" :key="at.id">
                                      <a :href="'/speaker/'+at.authors.slug">{{ at.authors.first_name }} {{ at.authors.last_name }}</a><em>, </em>
                                    </strong>
                                  </p>
                                </div>
                              </div>
                              <div class="name">
                                <div class="session">
                                  <p v-if="hasLecture(s)">
                                    <a :href="'/2022/'+s.agenda.lecture_slug">
                                      {{ s.agenda.lecture_name }}
                                      <template v-if="s.session.online === true">
                                        <br><span>(online lecture)</span>
                                      </template>
                                    </a>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </template>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import { SpringSpinner  } from 'epic-spinners'

export default {
    name: 'Agenda',
    props: ['info'],
    components: {
        SpringSpinner
    },
    data(){
        return{
            date: '',
            sessions: '',
            sessions2: '',
            sessions3: '',
            sessions_number: 0,
            stages: '',
            agenda: '',
            authors: '',
            lectures: '',
            base: false,
            ready: false,
            stageSessions1: [],
            stageSessions2: [],
            stageSessions3: [],
            log : console.log,
        }
    },
    computed: {
        orderedSessions: function(){
          return _.orderBy(this.sessions, 'order')
        },
        orderedSessions2: function(){
            return _.orderBy(this.sessions2, 'order')
        },
        getSess: function () {
          return this.sessions_number
        },
        getSess1: function () {
          return this.stageSessions1
        },
        getSess2: function () {
          return this.stageSessions2
        },
        getSess3: function () {
          return this.stageSessions3
        }
    },
    methods: {
        hasAuthors(testObj) {
          return _.has(testObj, 'agenda.authors')
        },
        hasLecture(testObj) {
          return _.has(testObj, 'agenda.lecture_slug')
        },
        getDate(){
            axios.get(process.env.VUE_APP_BASE_URL+'/codedive/items/agenda_settings')
                .then(response => {
                    this.date = response.data.data[0].event_date;
                })
        },
        getSessions(url){
            return axios.get(url)
                .then(response => {
                    this.sessions = response.data.data;
                })
        },
        getSessions2(url){
            return axios.get(url)
                .then(response => {
                    this.sessions2 = response.data.data;
                })
        },
        getSessions3(url){
            return axios.get(url)
                .then(response => {
                    this.sessions3 = response.data.data;
                })
        },
        getStages(){
            axios.get(process.env.VUE_APP_BASE_URL+'/codedive/items/agenda_stages')
                .then(response => {
                    this.stages = response.data.data;
                })
        },
        getAgenda(){
            this.agenda.forEach(a => {
                let v = this.lectures.find(v => v.id == a.lectures);
                if (typeof v !== "undefined") {
                  a.lecture_name = v.lecture_title;
                  a.lecture_slug = v.slug;
                  a.authors = v.lectures_authors;
                  a.authors.forEach(el => {
                      el.authors = this.authors.find(y => y.id == el.authors_id);
                  });
                } else {
                  a.lecture_name = "";
                  a.lecture_slug = "";
                  a.authors = [];
                }
            })
            // if(this.sessions.length > this.sessions2.length){
            //     this.sessions_number = this.sessions.length/2
            // }
            // else{
            //     this.sessions_number = this.sessions2.length/2
            // }
            this.ready = true;
        },
        collectAgendaList() {
          const orderedSess1 = _.orderBy(this.sessions, "order")
          const orderedSess2 = _.orderBy(this.sessions2, "order")
          const orderedSess3 = _.orderBy(this.sessions3, "order")
          const orderedAgenda = _.orderBy(this.agenda, "order")

          let agendaStage1 = []
          let agendaStage2 = []
          let agendaStage3 = []

          orderedAgenda.forEach(a => {
            if (a.stage === 1) {
              agendaStage1.push(a)
            } else if (a.stage === 2) {
              agendaStage2.push(a)
            } else {
              agendaStage3.push(a)
            }
          })

          let it = 0
          orderedSess1.forEach((s, idx) => {
            let f = {
              session: s,
              agenda: {
                lecture_name: "",
                lecture_slug: "",
                authors: [],
              }
            }
            if (s.type === "session") {
              if ( agendaStage1[it] !== 'undefined') {
                f.agenda = agendaStage1[it]
              }
              it++
              this.stageSessions1.push(f)
            } else {
              this.stageSessions1.push(f)
            }
          })

          it = 0
          orderedSess2.forEach(s => {
            let f = {
              session: s,
              agenda: {
                lecture_name: "",
                lecture_slug: "",
                authors: [],
              }
            }
            if (s.type === "session") {
              if (typeof agendaStage2[it] !== 'undefined') {
                f.agenda = agendaStage2[it]
              }
              it++
              this.stageSessions2.push(f)
            } else {
              this.stageSessions2.push(f)
            }
          })

          it = 0
          orderedSess3.forEach(s => {
            let f = {
              session: s,
              agenda: {
                lecture_name: "",
                lecture_slug: "",
                authors: [],
              }
            }
            if (s.type === "session") {
              if (typeof agendaStage3[it] !== 'undefined') {
                f.agenda = agendaStage3[it]
              }
              it++
              this.stageSessions3.push(f)
            } else {
              this.stageSessions3.push(f)
            }
          })

          // if (this.stageSessions2.length > this.stageSessions1.length) {
          //   this.sessions_number = this.stageSessions2.length
          // } else {
          //   this.sessions_number = this.stageSessions1.length
          // }
        },
        getLectures(url){
             return axios.get(url)
                .then(response => {
                    this.lectures = response.data.data;
                })
                .finally(() => this.base = true)
        },
        getAuthors(url){
            return axios.get(url)
                .then(response => {
                    this.authors = response.data.data;
                })
        },
        getAgendaList(url){
            return axios.get(url)
                .then(response => {
                    this.agenda = response.data.data;
                })
        },
        slug: function(str) {
            str = str.replace(/^\s+|\s+$/g, '-'); // trim
            str = str.toLowerCase();

            // remove accents, swap ñ for n, etc
            var from = "àáäâąèéëêęìíïîłńśźżòóöôùúüûñç·/_,:;ăț";
            var to   = "aaaaaeeeeeiiiilnszzoooouuuunc------at";
            for (var i=0, l=from.length ; i<l ; i++) {
                str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
            }

            str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
                .replace(/\s+/g, '-') // collapse whitespace and replace by -
                .replace(/-+/g, '-'); // collapse dashes

            return str;
        }
    },
    watch: {
        base: function(val) {
            setTimeout(()=>{
                this.getAgenda();
                this.collectAgendaList();
            },1000);
        }
    },
    created(){
        this.getSessions(process.env.VUE_APP_BASE_URL+'/codedive/items/agenda_sessions');
        this.getSessions2(process.env.VUE_APP_BASE_URL+'/codedive/items/agenda_sessions_for_stage2');
        this.getSessions3(process.env.VUE_APP_BASE_URL+'/codedive/items/agenda_sessions_for_stage3');

        this.getLectures(process.env.VUE_APP_BASE_URL+'/codedive/items/lectures?fields=*.*');

        this.getAuthors(process.env.VUE_APP_BASE_URL+'/codedive/items/authors');
        this.getAgendaList(process.env.VUE_APP_BASE_URL+'/codedive/items/agenda');
        // this.getStages();
        this.getDate();
    }
}
</script>

<style lang="scss">
    @import '@/assets/sass/variables.scss';
    @import '@/assets/sass/agenda.scss';
</style>
